// extracted by mini-css-extract-plugin
export default {"search-form":"Y_Qx flex-grow-1 form-group mb-0"};